// import moduleStyle from './switch-panel.module.scss';

import React, { useEffect } from 'react';
import { Box } from "@mui/material";

import CollapseCard from "components/Collapse";

// Utils
import SwitchDevice from 'utils/switch-device';

const SwitchPanel = ({ infoData, capabilityData, portData }) => {
  const { portTypes } = capabilityData;
  const portStatuses = [];
  for (const index in portData) {
    if (portData[index].hasOwnProperty('portStaStatus')) {
      portStatuses.push({
        ...portData[index],
      });
    }
  }

  const switchDevice = new SwitchDevice(
    infoData.deviceName,
    infoData.modelName,
    infoData.linkStatus === 'online',
    portTypes,
    portStatuses
  );

  useEffect(() => {
    const statusDom = document.getElementById('port-status-inner');
    const iconDom = document.getElementById('port-status-footer');
    if (statusDom && iconDom) {
      iconDom.style.display = 'none';
      iconDom.style.width = `${statusDom.offsetWidth}px`;
      iconDom.style.display = 'flex';
    }
  }, [infoData]);

  return (
    <CollapseCard showHeader={false} minWidth="480px">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "20px",
        }}
      >
        {switchDevice.panel.render()}
      </Box>
    </CollapseCard >
  )
}

export default SwitchPanel;